import React from 'react';
import { Button, Tooltip, theme } from 'antd';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { useDisplaySettings } from '../theme/DisplaySettingsContext';

/** Global toggle that blurs PII (client / vessel / project names, aliases, serials, SL#) across the app. */
export function PiiToggle() {
  const { redactNames, setRedactNames } = useDisplaySettings();
  const { token } = theme.useToken();
  return (
    <Tooltip title="Toggle PII visibility">
      <Button
        type="text"
        aria-label="Toggle PII visibility"
        aria-pressed={redactNames}
        icon={redactNames ? <EyeInvisibleOutlined /> : <EyeOutlined />}
        onClick={() => setRedactNames(!redactNames)}
        style={{ color: redactNames ? token.colorPrimary : token.colorText }}
      />
    </Tooltip>
  );
}
